<div *ngIf="qID === 2" >
    <app-add-borrower 
      *ngFor="let borrower of borrowersArray.controls; let i=index" 
      [index]="i" [borrower]="borrower" 
      (removed)="borrowersArray.removeAt($event)"
      [qID]="qID" 
      [displayErrors]="displayErrors"
      [showRemove]="showRemove && (borrowersArray.controls.length-1 == i)">
    </app-add-borrower>
	
    <div class="d-flex justify-content-center">
      <div *ngIf="borrowersArray.length > 0 && borrowersArray.length<maxBorrowerCount"  
            class="m-add-line-btn" 
            (click)="addBorrower()" 
            role="button" 
            tabindex="0" 
            (keypress)="simulateClick($event)">
        <span>{{"BORROWERS_DETAILS.QUESTION2.BUTTON_ADD_AND_SAVE"|translate}}</span>
      </div>
      <div *ngIf="borrowersArray.length === 0"  class="m-add-line-btn" 
          (click)="addBorrower()" 
          role="button" 
          tabindex="0" 
          (keypress)="simulateClick($event)">
        <i class="fa fa-plus" aria-hidden="true"></i>
        <span>{{"BORROWERS_DETAILS.QUESTION2.BUTTON_ADD"|translate}}</span>
      </div>
    </div>
</div>

<!-- <fieldset *ngIf="qID === 29"> -->
 <!-- <div class="row text-center">
    
    <div class="col">
      {{"BORROWERS_DETAILS.QUESTION29.NAME_TITLE"|translate}}
    </div>
    <div class="col">
      {{"BORROWERS_DETAILS.QUESTION29.ADDRESS_TITLE"|translate}}
    </div>
    <div class="col">
      {{"BORROWERS_DETAILS.QUESTION29.CHILDREN_TITLE"|translate}}
    </div>
    <div class="col">
      {{"BORROWERS_DETAILS.QUESTION29.MARITAL_STATUS_TITLE"|translate}}
    </div>
  </div>
  -->
  <!-- <app-add-borrower *ngFor="let borrower of borrowersArray.controls; let i=index" (removed)="borrowersArray.removeAt($event)" [childrenNumber]="childrenNumber" [maritalStatus]="maritalStatus" [index]="i" [borrower]="borrower" [qID]="qID"
    [displayErrors]="displayErrors" (removed)="borrowersArray.removeAt($event)">
  </app-add-borrower> -->
<!-- </fieldset> -->


// WEBPACK FOOTER //
// ./src/app/borrowers-array/borrowers-array.component.html